import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MappingGeofencedZoneGroup } from "../models/mappingGeofencedZoneGroup.model";
import { CrudService } from "../shared/grid/crud.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class MappingGeofencedZoneGroupService extends CrudService<MappingGeofencedZoneGroup> {
  constructor(http: HttpClient) {
    super('MappingGeofencedZoneGroup', http);
  }
  // TODO: to remove later once api implemented in standard/common way
  patch(id: any, payload: MappingGeofencedZoneGroup): Observable<Object> {
      return this.http.patch(this.getApiUrl(`${this.controllerName}/Patch/${id}`), payload);
  }
}
